document.addEventListener('DOMContentLoaded', () => {
	const dropdown = document.querySelector('.wp-block-fortytwo-capabilities-menu .dropdown');
	const toggleButton = dropdown.querySelector('.dropdown-toggle');
	const dropdownMenu = dropdown.querySelector('.dropdown-menu');

	// Toggle the menu on button click
	toggleButton.addEventListener('click', (e) => {
		e.preventDefault();

		const isOpen = dropdownMenu.classList.toggle('show'); // Toggle the menu
		toggleButton.setAttribute('aria-expanded', isOpen); // Update aria-expanded
	});

	// Close the menu when clicking outside
	document.addEventListener('click', (e) => {
		// Check if the click target is outside the button and menu
		if (!toggleButton.contains(e.target) && !dropdownMenu.contains(e.target)) {
			dropdownMenu.classList.remove('show');
			toggleButton.setAttribute('aria-expanded', 'false'); // Set aria-expanded to false
		}
	});
});